import { cn } from '@/lib/helpers/utils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@radix-ui/react-tabs';
import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import React from 'react';
import { capitalise } from '../../../app/utils/string';

interface groupProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  button: any;
  content?: any;
}

interface OrganisationNavProps extends React.HTMLAttributes<HTMLDivElement> {
  tabs: groupProps[];
  path: string;
  hideAboutTab?: boolean;
  tabListClasses?: string;
}

/**
 * Organisation Nav component
 * @return {JSX}
 */

const OrganisationNav = ({ tabs, path, hideAboutTab, tabListClasses }: OrganisationNavProps) => {
  const location = useLocation();
  const activeTab = location.pathname.split(path + '/').pop() || 'about';

  // Specific to Provider template as we don't show just the About tab
  if (tabs.length === 1 && hideAboutTab) {
    return null;
  }

  return (
    <Tabs defaultValue={!activeTab.includes(path) ? activeTab : 'about'}>
      <TabsList className={cn('text-center gap-3 inline-flex overflow-x-auto no-scrollbar', tabListClasses)}>
        {tabs.map((tab: any, i: number) => (
          <TabsTrigger asChild key={`tabsTrigger-${i}`} value={tab.alias}>
            <Link
              to={`${path}/${tab.alias !== 'about' ? tab.alias : ''}`}
              className="data-[state=active]:font-bold data-[state=active]:border-primary data-[state=active]:text-primary flex-grow px-3 md:px-8 py-2 text-center
                text-base border-b-2 border-white transition duration-200 ease-in-out flex-shrink-0"
              data-cy={`link:view--${tab.label}`}
            >
              {capitalise(tab.label)}
            </Link>
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab: any, i: number) => (
        <TabsContent key={`tabsContent-${i}`} value={tab}>
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default OrganisationNav;
